import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import { ContactProvider } from "@/context/ContactProvider.context";

import ContactCategoryList from "../components/contact/ContactCategory.component";
import ContactForms from "../components/contact/ContactForms.component";
import DocumentComponent from "../components/Document.component";
import i18n from "../i18n";

const Contact = (): React.JSX.Element => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("contact_us")} />
      <Container className="mb-5 pb-5">
        <Row>
          <Col xs={12}>
            <ContactProvider>
              <ContactCategoryList />
              <ContactForms />
            </ContactProvider>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Contact;
